var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1422 0C13.972 3.30497 16.695 6.028 20 5.85781C17.546 8.07576 17.546 11.9242 20 14.1422C16.695 13.972 13.972 16.695 14.1422 20C11.9242 17.546 8.07576 17.546 5.85781 20C6.028 16.695 3.30497 13.972 0 14.1422C2.45402 11.9242 2.45402 8.07576 0 5.85781C3.30497 6.028 6.028 3.30497 5.85781 0C8.07027 2.45402 11.9242 2.45402 14.1422 0Z",
    fill: "#FC6359"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRockIcon);
export default __webpack_public_path__ + "static/media/rock_Icon.09827879b8b2f843af8ee7e41a14dd47.svg";
export { ForwardRef as ReactComponent };